// extracted by mini-css-extract-plugin
module.exports = {"TeamLeaderboardPage":"TeamLeaderboardPage_TeamLeaderboardPage__3-GCZ"};